import React from "react";
import { fullWidthBox } from "@utils/styled-components";
import { useInView } from 'react-intersection-observer';
import styled from "styled-components";
import tw from "twin.macro";

import CaseTestimonialHeader from "@components/cases/testimonial/header";
import CaseTestimonialQuote from "@components/cases/testimonial/quote";
import CaseTestimonialOpinion from "@components/cases/testimonial/opinion";
import DetailsLarge from "@components/svg/details-large";

type TestimonialProps = {
  width: number,
  scroll: any,
  name: string
};

const Wrapper = tw.div`relative ml-30 mr-20`;

const WrapperOpinion = tw.div`
  w-full mb-80
  md:flex md:mb-30
  lg:mb-60
`;

const WrapperGradient = tw(fullWidthBox)`
  hidden
  md:block md:h-0 md:-z-1 md:mb-150
  lg:mb-290
`;

const Gradient = styled.div`
  background: linear-gradient(180deg, #FFFFFF 0%,
                                      #F5FDFF 100%);
  ${tw`absolute bottom-0 w-full h-500`}
`;

const DetailsWrapper = tw.div`
  absolute -top-44 -right-190 w-228 transform -scale-x-100
  lg:-top-110 lg:-right-110 lg:w-330
`;

const CaseTestimonial = ({ width, scroll, name }: TestimonialProps) => {
  const { ref, inView } = useInView();

  return (
    <Wrapper>
      <DetailsWrapper>
        <DetailsLarge />
      </DetailsWrapper>
      <CaseTestimonialHeader width={width} scroll={scroll} />
      <WrapperOpinion ref={ref} className={ inView && 'active' }>
        <CaseTestimonialQuote
          width={width}
          scroll={scroll}
          inView={inView}
          name={name}
        />
        <CaseTestimonialOpinion
          width={width}
          scroll={scroll}
          inView={inView}
          name={name}
        />
      </WrapperOpinion>
      <WrapperGradient>
        <Gradient />
      </WrapperGradient>
    </Wrapper>
  );
};

export default CaseTestimonial;
